import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface OtherUserVersionState {
	isGreenVersion: boolean;
	setIsGreenVersion: (isGreenVersion: boolean) => void;
}

export const useOtherUserVersionStore = create(
	subscribeWithSelector(
		persist(
			immer<OtherUserVersionState>((set) => ({
				isGreenVersion: true,
				setIsGreenVersion: (isGreenVersion: boolean) => set({ isGreenVersion }),
			})),
			{
				name: 'greenVersion',
			},
		),
	),
);
